import request from '@/utils/request'
let preBase = 'mixApi'

// 江苏兴业数币抽奖活动-登录
export const login = (data) => {
  return request({
    url: `${preBase}/cibDCEPLottery/login`,
    method: 'post',
    data,
    custom: true,
    hideLoading: false,
  })
}
// 江苏兴业数币抽奖活动-抽奖
export const lottery = (data) => {
  return request({
    url: `${preBase}/cibDCEPLottery/qqnbcl`,
    method: 'post',
    token: sessionStorage.getItem('jiangsuDigitalCoinLotteryToken'),
    data,
    hideLoading: true,
  })
}
// 江苏兴业数币抽奖活动-获取登录用户信息
export const getUserInfo = (data) => {
  return request({
    url: `${preBase}/cibDCEPLottery/getUserInfo`,
    method: 'post',
    token: sessionStorage.getItem('jiangsuDigitalCoinLotteryToken'),
    data,
  })
}
// 江苏兴业数币抽奖活动-我的奖品
export const myPrize = (data) => {
  return request({
    url: `${preBase}/cibDCEPLottery/myPrize`,
    method: 'post',
    token: sessionStorage.getItem('jiangsuDigitalCoinLotteryToken'),
    data,
    hideLoading: true,
  })
}
